module.exports = __webpack_public_path__ + "img/about-badminton.3fba3ba6.png";